<template>
  <div id="episodeCardBody">

    <lazy-background id="poster" class="centerBackground flexwrap"
                     :src="posterPath"
                     :placeholder='require("../assets/placeholder.png")' :blur="0" position="center">

      <div slot="content" id="posterContent">
        <div id="difficulty" class="flexwrap centercenter" :style="{backgroundColor: getBG(), marginLeft:'0.75vw'} ">
          {{ showDifficulty }}
        </div>
        <!--<div id="showsynopsis" v-if="!isMobile">
          {{currentShow.synopsis.french!=''&&profile.datas.estimated_level<3?currentShow.synopsis.french:currentShow.synopsis.sentence}}
        </div>-->
      </div>
    </lazy-background>


     <div id="info" class="plainTheme">
        <div id="infoshow">
          <h1 id="title" class="line-clamp" :class="[isMobile?'clamp2':'clamp1']" :title="currentShow.english_title.decodeEscapeSequence()">
            {{ currentShow.english_title.decodeEscapeSequence() }}
          </h1>

          <h3 id="titlefr" class="line-clamp clamp1" style="align-self: flex-end; display: flex;"
              v-if="!isMobile && currentShow.french_title.decodeEscapeSequence().split('(')[0].trim() != currentShow.english_title.decodeEscapeSequence()">
            {{ currentShow.french_title.decodeEscapeSequence().split('(')[0].trim() }}
          </h3>
          <h3 id="year" class="line-clamp clamp1"
              style="align-self: flex-end; display: flex; justify-self: flex-end" v-if="!isMobile">
            {{ currentShow.release_year }}
          </h3>


          <h2 id="seasontitle" class="clickable" @click="$router.push({name: 'catalog'})" v-if="currentShow.seasons.length>1">{{ currentSeason.english_title }}</h2>

        </div>

          <div id="attributes-row" class="darkTheme paddingRound mediumRoundAngles">

            <div>
              {{ Math.round(currentShow.episode_length) +1}}m
            </div>
            <div class="attributes" :style="{color: wpmColor}" :title="difficultyAlt.speed">
              <div v-html="wpmIcon"></div>
            </div>
            <div class="attributes" :style="{color: dialogueLengthColor}" :title="difficultyAlt.knowledge">
              <div v-html="dialogueLengthIcon"></div>
            </div>
            <span style="border: #eeeeee 1px solid">{{ getMaturity(currentShow) }}</span>
          </div>



        <!--<div id="share">
          <i class="fas fa-share-alt clickable" @click="shareOpen=true"></i>
        </div>-->
        <div  class="flexwrap centercenter" style="flex-direction: row; justify-self: flex-end" v-if="!isMobile">
          <div class="centercenter darkTheme paddingRound mediumRoundAngles" style="margin-right: 0.5vw">
            <span>{{seasonStats.points}}</span>
            <span style="font-size: 0.9em;">pts</span>
          </div>
          <div class="centercenter darkTheme paddingRound mediumRoundAngles" >
              <span  v-if="getHours(seasonStats.duration)!=0">{{getHours(seasonStats.duration)}}h</span>
              <span style="font-size: 0.9em;">{{getMinutes(seasonStats.duration)}}m</span>
          </div>
        </div>

        <!--<custom-select :options="currentShow.seasons" :selectedItem="selectedSeason"
                       @selected="selectSeason" name="Saison"
                       :color="currentShow.color" id="seasonselect" v-if="!isMobile || currentShow.seasons.length>1"
                       ></custom-select>-->
      </div>


    <div id="whitebg" class="lightTheme">
      <transition name="fade" mode="out-in" appear v-if="currentSeason.loaded">
        <div id="summarycontainer">

            <div id="dots" class="flexwrap centercenter" v-if="currentSeason.episodes[selectedEpisode].num!=-1">
              <div v-for="(episode, id) in currentSeason.episodes" :key="id">
                <div class="dot clickable flexwrap centercenter"
                     :class="{'dotselected' : episode == currentSeason.episodes[selectedEpisode],
                         'dotchecked' : checked(episode)||ongoing(episode)}" @click="selectEpisode(id)" v-if="episode.num != -1">
                 <!-- <i class="fas fa-check-circle" style="font-size: 0.7em" v-if="checked(episode)"></i>-->
                  <i class="fas fa-check-circle" style="font-size: 0.7em" v-if="checked(episode)"></i>
                  <i class="fas fa-sync-alt" style="font-size: 0.7em" v-if="ongoing(episode)"></i>
                </div>
              </div>

            </div>
          <transition name="slide-fade" mode="out-in">
            <div id="episodetitle" :key="'S'+selectedEpisode+'E'+selectedSeason">
              <h3 v-if="currentSeason.episodes[selectedEpisode].num!=-1" class="line-clamp" :class="[isMobile?'clamp2':'clamp1']" style="font-size: 1.5em; font-weight: bold">
                {{ currentSeason.episodes[selectedEpisode].num }} | {{
                  currentSeason.episodes[selectedEpisode].english_title.decodeEscapeSequence()
                }}</h3>
              <h3 v-else>
                Préparation</h3>
            </div>
          </transition>
          <div @click="episodedown" id="arrowleft" class="arrow" v-if="selectedEpisode>0">
            <i class="fas fa-chevron-left bigarrow"></i>
          </div>

          <transition name="slide-fade" mode="out-in" :key="currentSeason.episodes[selectedEpisode].num!=-1" >
            <div id="tiles"  :key="'S'+selectedEpisode+'E'+selectedSeason">
              <tile :inactive="false" :completed="currentEpisodeData.user_episode.learn_check"
                    :premium="((currentEpisodeData.vocab_sessions != null && currentEpisodeData.vocab_sessions.length>0) || profile.datas.today_session)"
                    :points="wordCount*5"
                    :earn="wordCount<30&&!currentEpisodeData.user_episode.watch_check?50:0"
                    :done="wordCount>=30"
                    :icon="'fa-graduation-cap'" :color1="'var(--learnColor)'" :color2="'#007a9d'" @click="learn">
                <template v-slot:title>
                  Learn
                </template>
                <template v-slot:description>
                  <div v-if="!currentEpisodeData.user_episode.learn_check" >Apprends le vocabulaire utile de l'épisode !</div>
                  <div v-else>{{ wordCount }} <span v-if="!currentEpisodeData.user_episode.watch_check">/ 30</span> mots appris !<br/>
                    <span style="font-size: 0.8em" v-if="wordCount<30 &&!currentEpisodeData.user_episode.watch_check">(Clique pour plus)</span>
                  </div>
                </template>
              </tile>

              <tile @click="watch" :completed="currentEpisodeData.user_episode.watch_check" :icon="'fa-tv-retro'"
                    :color1="'var(--watchColor)'" :color2="'#b92945'"
                    :alt="'Débloque le en faisant une session \'Learn\''"
                    :points="Math.round( currentEpisodeData.dialogue_length)*2"
                    :done="false"
                    :earn="!currentEpisodeData.user_episode.watch_check?Math.round(currentEpisodeData.dialogue_length)*2:0"
                    :inactive="!currentEpisodeData.user_episode.learn_check">

                <template v-slot:title>
                  Watch
                </template>
                <template v-slot:description>
                  <div v-if="!currentEpisodeData.user_episode.watch_check" >
                    Lis le synopsis et regarde l'épisode sur Netflix !
                    <!--<toggle :condition="currentEpisodeData.user_episode.watch_check" style="font-size: 0.9em">Marquer comme "vu" !</toggle>-->
                  </div>
                  <div v-else>
                    {{ Math.round( currentEpisodeData.dialogue_length) }} mins de dialogues vus !
                  </div>
                </template>
              </tile>

              <tile @click="startQuestions()" :completed="currentEpisodeData.user_episode.uq_check" :icon="'fa-tasks'"
                    :color1="'#ff8746'" :color2="'#c75e31'"

                    :alt="'Débloque le en regardant l\'épisode avec \'Watch\''"
                    :inactive="!currentEpisodeData.user_episode.watch_check"
                    :points="currentEpisodeData.user_episode.uq_score*10"
                    :earn="currentEpisodeData.user_episode.uq_check?0:currentEpisodeData.nb_questions*10"
                    :done="false"
                    :premium="currentSeason.episodes[selectedEpisode].num > 1" v-if="currentSeason.questions"
                    style="grid-column: 1/2">

                <template v-slot:title>
                  Check
                </template>
                <template v-slot:description>
                  <div v-if="!currentEpisodeData.user_episode.uq_check" >
                    Vérifie ta compréhension de l'épisode !
                  </div>
                  <div v-else>
                    <span v-if="currentEpisodeData.user_episode.uq_score == null">
                      QCM complété !
                    </span>
                    <span v-else>
                      {{currentEpisodeData.user_episode.uq_score}} / {{currentEpisodeData.nb_questions}} bonnes réponses au questionnaire !
                    </span>

                  </div>
                </template>
              </tile>

              <tile @click="startGame()" :completed="currentEpisodeData.user_episode.play_check" :icon="'fa-dice'"
                    :color1="'#23c26e'" :color2="'#159a54'"

                    :alt="'Débloque le en regardant l\'épisode avec \'Watch\''"
                    :inactive="!currentEpisodeData.user_episode.watch_check"
                    :points="currentEpisodeData.user_episode.play_score*5"
                    :done="false"
                    :earn="!currentEpisodeData.user_episode.play_check?wordCount*5-currentEpisodeData.user_episode.play_score*5:0"
                    :premium="currentSeason.episodes[selectedEpisode].num > 1" v-if="currentSeason.episodes[selectedEpisode].num!=-1"
                    :style="currentSeason.questions?'grid-column: 2/3':'grid-column: 1/3'"
              >

              <template v-slot:title>
                  Play
                </template>
                <template v-slot:description>
                  <div v-if="!currentEpisodeData.user_episode.play_check" >
                    Valide tes acquis avec un jeu de pendu !
                  </div>
                  <div v-else>
                    <span v-if="currentEpisodeData.user_episode.play_score == null">
                      Pendu complété !
                    </span>
                    <span v-else>
                      {{currentEpisodeData.user_episode.play_score}} / 10 mots trouvés au pendu !
                    </span>

                  </div>
                </template>
              </tile>



            </div>
          </transition>

          <div @click="episodeup" id="arrowright" class="arrow"
               v-if="selectedEpisode<currentSeason.episodes.length-1">
            <i class="fas fa-chevron-right bigarrow"></i>
          </div>
        </div>
      </transition>
      <transition name="fade" mode="out-in" appear v-else>
        <loading-logo></loading-logo>
      </transition>
    </div>
    <popup v-if="shareOpen" @close="shareOpen=false">
      <share></share>
    </popup>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {lock} from '../main'
import {API_URL} from "@/App";
import axios from "axios";

export default {
  name: "episodeCard",
  components: {
    Tile: () => import(/* webpackPrefetch: true */ '@/components/tile.vue'),
    Popup: () => import(/* webpackPrefetch: true */ '@/components/popup.vue'),
    LoadingLogo: () => import(/* webpackPrefetch: true */ '@/components/loadingLogo.vue'),
    customSelect: () => import(/* webpackPrefetch: true */ '@/components/customSelect.vue'),
    share: () => import(/* webpackPrefetch: true */ '@/components/share.vue')
  },
  created() {
    this.cameBycreated = true;
    // Sélectionne le dernier épisode dont une session a été effectuée par l'utilisateur
    if(this.currentSeason.loaded) {
      this.selectEpisode(this.nextEpisode());
      this.currentShow.seasons.forEach(
          (item, index) => {
            if (item.id === this.currentSeason.id) {
              this.selectedSeason = index
            }
          }
      );
    }


    //window.addEventListener("keydown", this.getKey);
  }
  ,
  destroyed() {
    //window.removeEventListener("keydown", this.getKey);
  },
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
      'dataLoaded',
      'appStep',
      'apiData',
      'authenticated',
      'states',
      'routeParams',
      'routeName',
      'dataLoaded'
    ]),
    ...mapGetters('show', [
      'currentShow',
      'currentSeason',
      'currentEpisodeData'
    ]),
    seasonStats: function() {
      // par défaut on renvoie un objet avec des valeurs à 0
      let stats = {
        points: 0,
        duration: 0
      }
      // Si datas.seasons est chargé, on cherche si currentSeason est entamé
      // Si oui on récupère les données correspondantes
      if(this.dataLoaded.ongoing) {
        this.profile.datas.user_seasons.forEach((element) => {
          if(element.season_id === this.currentSeason.id) {
            stats.points = element.points;
            stats.duration = element.duration
            return
          }
        })
      }
      return stats
    },
    posterPath: function (){
      if(this.isMobile){
        return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/' + this.currentShow.poster_path
      }
      return 'https://learnandwatch.s3.eu-west-3.amazonaws.com/' + this.currentShow.poster_path
    },
    netflixURL: function () {
      return 'https://www.netflix.com/watch/' + this.epData.netflix_id
    }
    ,
    wordCount: function () {
      if (this.currentEpisodeData.user_episode.learn_number != null) {
        return this.currentEpisodeData.user_episode.learn_number
      }
      return 0
    },
    wpmColor: function () {
      //let proportion_over_238wpm = this.currentShow.proportion_over_238wpm
      let proportion_over_260wpm = this.currentShow.proportion_over_260wpm
      if (proportion_over_260wpm < 73) {
        this.difficultyAlt.speed = "Dialogues très rapides";
        return this.colorsDiffictulty[2]
      } else if (proportion_over_260wpm < 93) {
        this.difficultyAlt.speed = "Quelques dialogues très rapides";
        return this.colorsDiffictulty[1]
      } else {
        this.difficultyAlt.speed = "Dialogues à vitesse correcte";
        return this.colorsDiffictulty[0]
      }
    }
    ,
    wpmIcon: function () {
      let proportion_over_260wpm = this.currentShow.proportion_over_260wpm
      if (proportion_over_260wpm < 73) {
        return '<i class="fas fa-gauge-max"></i>'
      } else if (proportion_over_260wpm < 93) {
        return '<i class="fas fa-gauge-med"></i>'
      } else {
        return '<i class="fas fa-gauge-min"></i>'
      }

    }
    ,
    dialogueLengthColor: function () {
      let dialogueLength = this.currentShow.dialogue_length
      if (dialogueLength < 20) {
        this.difficultyAlt.knowledge = "Moins de 20 minutes de dialogues";
        return this.colorsDiffictulty[0]
      } else if (dialogueLength < 40) {
        this.difficultyAlt.knowledge = "Plus de 20 minutes de dialogues";
        return this.colorsDiffictulty[1]
      } else {
        this.difficultyAlt.knowledge = "Plus de 40 minutes de dialogues";
        return this.colorsDiffictulty[2]
      }
    }
    ,
    dialogueLengthIcon: function () {
      return '<i class="fas fa-comments"></i>'
    }
    ,
    showDifficulty: function () {
      let difficulty = this.currentShow.difficulty_level;
      if (difficulty == 0) {
        return 'A1'
      } else if (difficulty == 1) {
        return 'A2'
      } else if (difficulty == 2) {
        return 'B1'
      } else if (difficulty == 3) {
        return 'B2'
      } else if (difficulty == 4) {
        return 'C1'
      } else {
        return 'C2'
      }
    }
  },
  methods: {
    ...mapActions('global', [
      'set_appStep',
        'set_carousselNavTransition'
    ]),
    ...mapActions('show', [
      'set_currentEpisodeData',
    ]),
    ...mapActions('session', [
      'set_sessionType',
    ]),
    ...mapActions('game', [
      'set_gameOn',
      'set_gameWordsList',
      'set_gameWordsListLoaded',
      'set_gameOrigin'
    ]),
    episodeup: function () {
      if (this.selectedEpisode < this.currentSeason.episodes.length - 1) {
        this.selectEpisode(this.selectedEpisode + 1)
      }
    },
    episodedown: function () {
      if (this.selectedEpisode > 0) {
        this.selectEpisode(this.selectedEpisode - 1)
      }
    },
    checked: function (episode) {
      if (episode.user_episode != null && episode.user_episode.check ===2) {
        return true
      }
      return false
    },
    ongoing: function (episode) {
      if (episode.user_episode != null && episode.user_episode.check === 1) {
        return true
      }
      return false
    },
    nextEpisode: function () {
      let lastChecked = 0;
      for (const id of this.currentSeason.episodes.keys()) {
        if (this.ongoing(this.currentSeason.episodes[id]) || this.checked(this.currentSeason.episodes[id])) {
          lastChecked = id
        }
      }
      //return Math.min(lastChecked+1, this.currentSeason.episodes.length-1);
      return lastChecked
    },
    getBG: function () {
      let difficulty = this.currentShow.difficulty_level;
      if (difficulty > -1 && difficulty < 5) {
        return this.colorLevel[difficulty]
      } else {
        return "#000000"
      }
    },
    getNum(n) {
      return n > 9 ? "" + n : "0" + n;
    }
    ,
    getMaturity: function (show) {
      if (show.maturityLevel == 35) {
        return 'ALL'
      }
      if (show.maturityLevel == 41) {
        return '7+'
      }
      if (show.maturityLevel == 80) {
        return '13+'
      }
      if (show.maturityLevel == 110) {
        return '16+'
      }
      if (show.maturityLevel == 1000) {
        return '18+'
      }
    }
    ,
    getHours: function(duration){
      return Math.floor(Math.round(duration)/60)
    },
    getMinutes: function(duration){
      return Math.round(duration)-this.getHours(duration)*60
    },
    selectSeason: function (index) {
      this.selectedSeason = index;
      //this.selectEpisode(0);
      this.$router.push({params: {seasonId: this.currentShow.seasons[index].id}});
    }
    ,
    selectEpisode: function (id) {
      this.selectedEpisode = id;
      this.set_currentEpisodeData(this.currentSeason.episodes[this.selectedEpisode]);
      //let epId = this.currentSeason.episodes[this.selectedEpisode].id;

    },
    learn: function () {
      if(this.wordCount<30){
        this.set_carousselNavTransition(false)
        if (!this.authenticated) {
          this.loggedByLearn = true;
          if(!this.$isDebug) {
            gtag('event', 'LearnClicked', {
              'event_category': 'Session',
              'event_label': 'new_user'
            })
          }
          this.$session.set('seasonIdBeforeLog', this.routeParams.seasonId)
          //lock.show()
        } else {

          if(!this.$isDebug) {
            gtag('event', 'LearnClicked', {
              'event_category': 'Session',
              'event_label': 'authenticated'
            })

            if(this.wordCount === 0) {
              fbq('track', 'First Session');
            }
            else if(this.wordCount<20) {
              fbq('track', 'Second Session');
            }
            else {
              fbq('track', 'Third Session');
            }
          }
          if (this.appStep === this.states.MENU) {
            this.set_appStep(this.states.ONGOING_SESSION);
            this.set_sessionType('episode');
          }
        }
      }

    },
    watch: function () {
      this.set_carousselNavTransition(false)

      if(!this.$isDebug) {
        gtag('event', 'NetflixClicked', {
          'event_category': 'Session'
        })

        fbq('track', 'Watch Clicked');
      }
      //this.$session.start();
      /*
      if (this.appStep === this.states.MENU) {
        //this.retrieveNextEpisode();
        this.episodeup();
      }*/
      this.fetchLemmas()
      this.set_appStep(this.states.WATCH_CARD)
    },
    retrieveNextEpisode: function () {
      // On va trouver l'id du prochain épisode disponible de la série
      let currentData = this.findEpisodebyId(this.currentEpisodeData.id);
      if (this.currentShow.seasons[currentData.lastSeason - 1].episodes.length > currentData.lastEpisode + 1) {
        currentData.lastEpisode++;
      } else if (this.currentShow.seasons.length > currentData.lastSeason + 1) {
        currentData.lastEpisode = 0;
        currentData.lastSeason++;
      }
      // On cherche si le show existe déjà dans les cookies, on le supprime si c'est le cas
      // Puis on ajoute le nouveau show en première place pour indiquer qu'il est le dernier vu
      if (this.$cookies.isKey('onGoingSeries')) {
        let tempOnGoingSeries = JSON.parse(this.$cookies.get('onGoingSeries'));
        let index = tempOnGoingSeries.findIndex(show => show.id == currentData.id)
        if (index !== -1) {
          tempOnGoingSeries.splice(index, 1)
        }
        tempOnGoingSeries.splice(0, 0, currentData);
        this.$cookies.set('onGoingSeries', JSON.stringify(tempOnGoingSeries))
      } else {
        let tempArray = [currentData];
        this.$cookies.set('onGoingSeries', JSON.stringify(tempArray))
      }
      //let nextEpisodeId = this.currentShow.seasons[currentData.lastSeason - 1].episodes[currentData.lastEpisode - 1].id;
    },
    findEpisodebyId: function (id) {
      let current = {
        id: this.currentShow.id,
        lastEpisode: 0,
        lastSeason: 0
      }
      for (let i = 0; i < this.currentShow.seasons.length; i++) {
        for (let j = 0; j < this.currentShow.seasons[i].episodes.length; j++) {
          if (this.currentShow.seasons[i].episodes[j].id == id) {
            current.lastSeason = i + 1;
            current.lastEpisode = j + 1;
          }
        }
      }
      return current;
    },

    startGame() {
        this.set_carousselNavTransition(false)
        this.set_gameOn(true)
        this.set_appStep(this.states.ONGOING_GAME)
        this.set_gameOrigin("episode")
    },

    startQuestions() {
      /*if(!this.currentEpisodeData.user_episode.uq_check || this.currentEpisodeData.user_episode.uq_score==null){*/

      if(!this.$isDebug) {
        gtag('event', 'Questions', {
          'event_category': 'Session'
        })

        fbq('track', 'Questions Clicked');
      }
        this.set_carousselNavTransition(false)
        this.set_appStep(this.states.ONGOING_QUESTIONS)
      /*}*/
    },

    fetchLemmas() {
      const url = `${API_URL}/api/episode_vocabulary/` + this.currentEpisodeData.id + '/'

      this.$webAuth.checkSession({}, (error, authResult) => {
        if(!error) {
          axios.get(url, {headers: {Authorization: `Bearer ${authResult.accessToken}`}})
              //this.$http.get('http://localhost:8000/api/episode/' + episode.id + '/')
              .then(response => {
                return response.data;
              })
              .then(data => {
                    this.set_gameWordsList(data);
                    this.set_gameWordsListLoaded(true)
                  }
              );
        }
        else {
          console.log(error)
        }
      })
    },

    getKey(event) {
      if (this.appStep === this.states.MENU) {
        if (event.key === "ArrowRight") {
          this.start();
          event.preventDefault();
        }
      } else if (this.appStep === this.states.SYNOPSIS) {
        if (event.key === "ArrowRight") {
          this.start();
          window.open(this.netflixURL);
          event.preventDefault();
        }
      }
    }
  },
  watch: {
    'currentSeason.loaded': function () {
      this.selectEpisode(this.nextEpisode());
      this.currentShow.seasons.forEach(
          (item, index) => {
            if (item.id === this.currentSeason.id) {
              this.selectedSeason = index
            }
          }
      );
    },

    'currentSeason.id': function() {
      this.selectEpisode(this.nextEpisode());
      this.currentShow.seasons.forEach(
          (item, index) => {
            if (item.id === this.currentSeason.id) {
              this.selectedSeason = index
            }
          }
      );
    },
  },
  data() {
    return {
      cameBycreated: false,
      loggedByLearn: false,
      selectedSeason: 0,
      selectedEpisode: 0,
      picked: 1,
      //states: states,
      difficultyAlt: {
        intensity: "",
        speed: "",
        knowledge: "",
      },
      colorsDiffictulty: ['#55FF8C', '#FFE96E', '#FF5E3D'],
      feedbackEpisode: 0,
      feedbackVocab: 0,
      feedbackUserLevel: 0,
      colorLevel: {
        0: "#56cdac",
        1: "#439f40",
        2: "#f49631",
        3: "#EB3B3B",
        4: "#40407F"
      },
      screenWidth: window.screen.width,
      shareOpen: false
    }
  }
}
</script>

<style scoped>
#episodeCardBody {
  display: grid;
  grid-template-columns: 20vw 1fr;
  grid-template-rows: auto 1fr;
  height: 100%;
  width: 100%;
}

#poster {
  grid-column: 1 / 2;
  grid-row: 1/3;
  z-index: auto;
  overflow: hidden;
}

#posterContent{
  position: relative;
  height: 32vw;
  width: 20vw;
}

#difficulty {
  position: absolute;
  top:0;
  right:0;
  width: 3vw;
  height: 2vw;
  font-weight: bold;
  border-radius: 0 0 0 1vw;
  color: white;
  padding-left: 0.2vw;
  z-index: auto;
}

#showsynopsis{
  height: fit-content;
  background: linear-gradient(#00000000, var(--darkColor));
  position: absolute;
  bottom: 0;
  left:0;
  padding: 8vw 1vw 1vw 1vw;
  text-shadow: 0px 0px 0.7vw var(--darkColor);
  font-style: italic;
  font-size: 1.15em;
  /*font-weight: bold;*/
  /*backdrop-filter: blur(0.5vw);
  -webkit-mask-image: -webkit-linear-gradient(top, rgba(0,0,0,0) 0, rgba(0,0,0,1) 10vw, rgba(0,0,0,1));
  mask-image: -webkit-linear-gradient(top, rgba(0,0,0,0) 0, rgba(0,0,0,1) 10vw, rgba(0,0,0,1));*/
  color: var(--lightColor);

}

.attributes {
  font-weight: bold;
  display: flex;
}

#info {
  grid-row: 1 / 2;
  grid-column: 2/3;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  grid-gap: 0.8vw;
  padding: 1vw;
  align-items: center;
}

#infoshow {
  grid-row: 1/2;
  grid-column: 1/3;
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-template-rows: auto auto auto;
  grid-column-gap: 0.5vw;
  height: fit-content;
}

#title {
  grid-column: 1/3;
  grid-row: 1/2;
}
#seasontitle {
  grid-column: 3/4;
  grid-row: 1/2;
  justify-self: flex-end;
  align-self: flex-end;
}

#titlefr {
  grid-column: 1/2;
  grid-row: 2/3;
}

#year {
  grid-column: 2/3;
  grid-row: 2/3;
}

#seasonselect {
  grid-column: 2/4;
  grid-row: 2/3;
  width: fit-content;
  justify-self: flex-end;
  z-index: 20;
}

.progressionBubble{
  flex-direction: column;
  width: 3vw;
  height: 3vw;
  margin-right: 0.5vw;
  border-radius: 4vw;
  text-align: center;
  font-weight: bold;
  padding: 0.5vw;
}

.bubble2{
  width: 2vw;
  height: 2vw;
}

#attributes-row {
  grid-column: 1/2;
  grid-row: 2/3;
  display: flex;
  width: fit-content;
  height: fit-content;
  align-items: center;
}

#attributes-row > * {
  margin-right: 0.5vw;
}

#share {
  grid-column: 3/4;
  grid-row: 1/2;
  justify-self: flex-end;
}

#whitebg{
  grid-row: 2/3;
  grid-column: 2/3;
  height: 100%;
  width: 100%;
}

#summarycontainer {
  /*border-top: 2px solid #bbbbbb;*/
  display: grid;
  grid-template-columns: 4vw 1fr 4vw;
  grid-template-rows: auto 1fr;
  padding: 1.5vw 0 1vw 0;
  grid-gap: 1vw;
  height: calc(100% - 2.5vw);
  align-items: center;
  justify-items: center;
  align-self: center;

}

.arrow {
  height: 100%;
  width: 100%;
  font-size: 1.2em;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

#arrowleft {
  grid-column: 1/2;
  grid-row: 2/3;
}

#arrowright {
  grid-column: 3/4;
  grid-row: 2/3;
}

#summary {
  display: grid;
  grid-column: 2/3;
  grid-row: 1/2;
  grid-gap: 0.5vw;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 1fr;
  align-items: center;
}

#episodetitle{
  grid-row: 1/2;
  grid-column: 1/4;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 0.9em;
}

#countwords {
  grid-row: 1/2;
  grid-column: 2/3;
  border: 0.1vw var(--lightGrey) solid;
  font-size: 90%;
}

.bigarrow {
  font-size: 150%;
}

#dots {
  grid-row: 1/2;
  grid-column: 2/4;
  background-color: var(--plainColor);
  padding: 0 0.5vw 0.5vw 1vw;
  border-radius: 0 0 0 0.8vw;
  margin-top: -1.75vw;
  justify-self: flex-end;
  align-self: flex-start;
}

.dot {
  height: 0.5vw;
  width: 0.5vw;
  min-height: 0.5vw;
  min-width: 0.5vw;
  max-height: 0.5vw;
  max-width: 0.5vw;
  background: rgba(255,255,255,0.3);
  border-radius: 0.5vw;
  margin-right: 0.5vw;
  color: var(--lightColor);
}

.dotselected {
  background-color: var(--lightplainColor);
  color: var(--lightplainColor);
}

.dotchecked {
  /*border-color: #F91E48;*/
  background-color: var(--plainColor);
}


#tiles {
  position: relative;
  grid-column: 2/3;
  grid-row: 2/3;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 1vw;
  width: fit-content;
  height: 100%;
  align-items: center;
  justify-content: center;
  justify-items: center;
}



.button {
  margin: 0.25vw;
}

span.line {
  display: inline-block;
}

.fade-enter-active {
  transition: all .4s;
  -webkit-transition: all .4s;
  -ms-transition: all .4s;
}

.fade-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

@media screen and (max-device-width: 767px) {

  #episodeCardBody {
    grid-template-columns: 30vw 1fr;
    grid-template-rows: 45vw 1fr;
  }

  #poster {
    grid-column: 1 / 2;
    grid-row: 1/2;
  }

  #difficulty {
    width: 8vw;
    height: 6vw;
    border-radius: 0 0 0 4vw;
    padding-left: 0.8vw;
  }

  #info {
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto 1fr;
    grid-gap: 1.5vw;
    padding: 3vw;
  }

  #seasonselect {
    grid-column: 1/2;
    grid-row: 3/4;
    justify-self: flex-start;
  }

  #attributes-row {
    grid-column: 1/3;
    grid-row: 2/3;
    width: fit-content;
  }

  #attributes-row > * {
    margin-right: 2vw;
  }

  #whitebg {
    grid-row: 2/3;
    grid-column: 1/3;
    height: calc(100% - 4vw);
    padding-bottom: 4vw;

  }

  #summarycontainer {
    grid-template-columns: 8vw 1fr 8vw;
    grid-template-rows: auto 1fr;
    position: relative;
    height: fit-content;
    padding: 0;
  }

  #episodetitle{
      padding: 3vw 4vw 2vw 4vw;
      height: fit-content;
      min-height: 10vw;
  }

  #seasontitle {
    grid-column: 1/3;
    grid-row: 2/3;
    justify-self: flex-end;
    align-self: center;
  }

  #buttons {
    /*margin-left: 2vw;*/
  }

  .button {
    margin: 1vw;
  }

  #dots {
    position: absolute;
    right: 0;
    top: 2.5vw;
    padding: 0 1.2vw 1.6vw 3vw;
    border-radius: 0 0 0 3.2vw;
    max-width: calc(100% - 25.2vw);
    margin-top: -3.5vw;
  }

  .dot {
    height: 1.8vw;
    width: 1.8vw;
    min-height: 1.8vw;
    min-width: 1.8vw;
    max-height: 1.8vw;
    max-width: 1.8vw;
    /*background: var(--lightGrey);*/
    border-radius: 1.8vw;
    margin-right: 1.8vw;
  }


  .bigarrow {
    font-size: 140%;
    padding: 2vw;
  }

  #posterContent{
    position: absolute;
    width: 30vw;
    height:0;
  }

  #tiles {

    position: relative;
    grid-column: 2/3;
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    width: fit-content;
    height: 100%;

    align-items: center;
    justify-content: center;
    justify-items: center;
    grid-gap: 3vw;
  }


  .progressionBubble{
    width: 15vw;
    height: 15vw;
    margin-right: 1vw;
    margin-left: 1vw;
    border-radius: 12vw;
    padding: 2vw;
  }

  .bubble2{
    width: 10vw;
    height: 10vw;
    padding: 1.5vw;
  }

}
</style>
